import {gql} from '@apollo/client'

export default gql`
  query GetSurvey($surveyId: ID!, $userId: ID) {
    survey(id: $surveyId, userId: $userId) {
      id
      title
      survey_type
      completed_date
      pc_edge
      pc_chrome
      pc_firefox
      pc_other
      mac_safari
      mac_chrome
      mac_firefox
      mac_other
      ios_tablet
      ios_smartphone
      ios_safari
      ios_edge
      ios_chrome
      ios_firefox
      ios_other
      android_tablet
      android_smartphone
      android_edge
      android_chrome
      android_firefox
      android_other
      vpn
      ease_of_access
      ease_of_navigation
      clear_instructions
      understood_expectation
      interesting_manner
      pe_realistic
      pe_useful
      balance_pe_vs_course
      instructions_appropriate
      reading_listening_appropriate
      time_taken
      module_length
      overall_assessment
      recommendations
      observations
      improved_proficiency
      improved_job_performance
      challenging_aspects
      most_useful
      least_useful
      focused_on_material
      user {
        id
        user_name
        current_tl_or_sme
        tl_sme_lot
        current_former_fao
        fao_rank
        fao_lot
        fao_assignment
        ilr
        ilr_reading
        ilr_listening
        ilr_speaking
        dlpt
        dlpt_reading
        dlpt_listening
        dlpt_speaking
        opi
        opi_reading
        opi_listening
        opi_speaking
        other
        other_string
        other_reading
        other_listening
        other_speaking
        section_1_completed_date
      }
      problems {
        id
        page_number
        problem_type
        content
      }
      section_2_completed_date
      section_3_completed_date
    }
  }
`